import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT, MENU_WIDTH } from '../../../styles/constants';

const menuHeaderHeight = '48px';
const safeAreaHeight = '16px';

export const useStyles = makeStyles<Theme>()((theme) => ({
  menuWrapper: {
    width: MENU_WIDTH,
    minWidth: MENU_WIDTH,
    height: '100%',
    minHeight: 0,
    borderRight: `1px solid ${theme.palette.border.main}`,

    [theme.breakpoints.down('md')]: {
      borderRight: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100vw',
      height: MAX_PAGE_HEIGHT,
      zIndex: 1003,
      marginTop: '0',
    },
  },
  menuHeader: {
    display: 'none',

    [theme.breakpoints.down('md')]: {
      display: 'flex',
      gap: theme.spacing(1),
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
      height: `calc(${menuHeaderHeight} )`,
    },
  },

  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.menu.contrastText,
  },

  menuContainer: {
    paddingTop: theme.spacing(1),
    backgroundColor: theme.palette.menu.primary,
    borderRadius: '0 0 4px 4px',
    padding: theme.spacing(1),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    // boxShadow: '5px 5px 4px 0px #00000040',

    [theme.breakpoints.down('md')]: {
      marginTop: 0,
      paddingTop: '16px',
      height: '100%',
    },
  },

  menuItemLink: {
    color: theme.palette.menu.contrastText,
    textDecoration: 'unset',
  },
  divider: {
    flexShrink: 0,
    alignSelf: 'stretch',
    height: '2px',
    minHeight: '2px',
    margin: theme.spacing(1),
    backgroundColor: theme.palette.menu.divider,
    borderRadius: '1px',
  },
  menuList: {
    padding: 0,
    margin: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100% - ${safeAreaHeight})`,
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    paddingBottom: safeAreaHeight,
    [theme.breakpoints.down('md')]: {
      height: `calc(100% - ${menuHeaderHeight} - ${safeAreaHeight})`,
      padding: theme.spacing(0, 1),
      paddingBottom: safeAreaHeight,
    },
  },
  policyLinksSection: {
    padding: theme.spacing(0.5, 0),
    paddingLeft: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    color: theme.palette.menu.contrastText,
  },
  bottomInfoSection: {
    marginTop: 'auto',
  },
  versionText: {
    paddingLeft: theme.spacing(1.5),
    color: theme.palette.menu.contrastText,
  },
  policyLinksWrap: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    alignContent: 'flex-start',
    columnGap: theme.spacing(2),
    rowGap: theme.spacing(0.75),
    width: '100%',
  },
  policyLinkButton: {
    border: 0,
    background: 'none',
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    font: 'inherit',
    color: 'inherit',
    textAlign: 'left',
    width: 'fit-content',
    maxWidth: '100%',
    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.menu.contrastTextDark,
    },
  },
  themeMenuRow: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.menu.contrastText,
    borderRadius: '10px',
    transition: 'background-color 0.3s ease, color 0.3s ease',

    '& > div': {
      width: '12px',
    },
    '&:hover': {
      backgroundColor: theme.palette.menu.primaryDark,
      color: theme.palette.menu.contrastTextDark,
    },
  },
  menuItem: {
    display: 'flex',
    padding: theme.spacing(1.5),
    alignItems: 'center',
    flex: 1,
    color: theme.palette.menu.contrastText,
    transition: 'background-color 0.3s ease, color 0.3s ease',
    position: 'relative',
    zIndex: 0,
    borderRadius: '10px',

    '& span': {
      width: '100%',
    },

    [theme.breakpoints.down('md')]: {
      '&:first-of-type': {
        marginTop: '0',
        paddingTop: '8px',
      },
    },
    '& svg:first-of-type': {
      height: '20px',
      width: '20px',
      marginRight: '4px',
    },
  },
  menuItemClickable: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.menu.primaryDark,
      color: `${theme.palette.menu.contrastTextDark}`,
    },
  },

  userName: {
    flex: 1,
    color: theme.palette.font.secondary,
  },
  closeMenuIcon: {
    color: theme.palette.menu.contrastText,
  },
  counter: {
    marginLeft: '4px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default,
    maxWidth: '20px',
    width: '20px',
    maxHeight: '20px',
    textAlign: 'center',
    borderRadius: '50%',
  },
  active: {
    backgroundColor: theme.palette.menu.secondary,
    color: `${theme.palette.menu.secondaryContrastText} !important`,
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: `${theme.palette.menu.secondaryDark} !important`,
    },
  },
  mobileMenuItemLink: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  logoutMenuItem: {
    color: `${theme.palette.error.main} !important`,
    '&:hover': {
      color: `${theme.palette.error.main} !important`,
    },
  },
}));
